export default class ErrorWithUserMessage extends Error {
    constructor(message = '') {
        super(message);
        this.message = message;
        // for correct instanceof checks
        Object.setPrototypeOf(this, ErrorWithUserMessage.prototype);
    }
}
